import type { AnalyticsIdentity } from './types';

const ACS_CUSTOMER_ID_COOKIE = 'acs_ngn';

const getDocumentCookie = (): string => {
  try {
    return typeof document === 'undefined' ? '' : document.cookie;
  } catch {
    return '';
  }
};

export const getAcsCustomerId = (cookieHeader?: string): string | undefined => {
  const cookiePrefix = `${ACS_CUSTOMER_ID_COOKIE}=`;
  const cookie = (cookieHeader ?? getDocumentCookie())
    .split(';')
    .map(entry => entry.trim())
    .find(entry => entry.startsWith(cookiePrefix));

  if (!cookie) return undefined;

  const encodedPayload = cookie.slice(cookiePrefix.length);
  if (!encodedPayload) return undefined;

  try {
    const payload = new URLSearchParams(decodeURIComponent(encodedPayload));
    return payload.get('eid')?.trim() || undefined;
  } catch {
    return undefined;
  }
};

export const getAnalyticsIdentity = (isAuthenticated: boolean): AnalyticsIdentity => ({
  customer_id: isAuthenticated ? getAcsCustomerId() : undefined,
  user_type: isAuthenticated ? 'logged in' : 'logged out',
});
